import resumeService from "@/services/resume";
export default {
    state: {
        resumeDefault: {
            degreeType: null,
            major: null,
            speciality: null,
            cvs: [],
            files: []
        },
        resume: {}
    },
    mutations: {
        setResume(state, payload) {
            state.resume = JSON.parse(JSON.stringify({ ...state.resumeDefault, ...payload}));
        }
    },
    actions: {
        async setResume({ commit }, payload) {
            payload.degreeType = payload.degreeType || 1;
            payload.speciality = payload.id || null;
            payload.major = payload.major.id || null;
            commit("setResume", payload);
        },
        resetResume({ commit }) {
            commit("setResume", {});
        },
        async removeResumeCvs(context, payload) {
            await resumeService.removeCvs(payload);
        },
        async removeResume(context, payload) {
            const { id } = payload;
            await resumeService.remove(id);
        }
    }
};
